import PropTypes from 'prop-types';
import React from 'react';
import styles from './prepaidCard.module.scss';

const Balance = ({ title, balance }) => {
  return (
    <div className={styles.balance}>
      <span className={styles.balanceTitle}>{title}</span>
      <span className={styles.balanceBalance}>{balance}</span>
    </div>
  );
};

Balance.propTypes = {
  title: PropTypes.string.isRequired,
  balance: PropTypes.string.isRequired,
};

export default Balance;
